import { Merchant } from "Components/Hunter/Merchants/Detail/Tabs/Merchant/Merchant";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Box, Stack } from "@mui/material";

type Props = {
  publicPartyID: string;
  merchantPublicID: string;
};

export const AmlMerchantDetailPageContent = ({
  publicPartyID,
  merchantPublicID,
}: Props) => (
  <Stack alignItems="center">
    <Box width="100%" maxWidth="600px">
      <PrimaryPaper>
        <Merchant
          publicPartyID={publicPartyID}
          merchantPublicID={merchantPublicID}
          isReadOnly
          isNoteHidden
        />
      </PrimaryPaper>
    </Box>
  </Stack>
);
